import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const levels = [23.6, 38.2, 50, 61.8, 78.6, 100, 127.2, 161.8];

export default function FibonacciNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #d97706',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#f59e0b' }}>
        🌀 Fibonacci
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
        <select
          value={data.level_type || 'retracement'}
          onChange={(e) => onChange('level_type', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="retracement">Retracement</option>
          <option value="extension">Extension</option>
        </select>
        <select
          value={Number(data.level ?? 61.8)}
          onChange={(e) => onChange('level', parseFloat(e.target.value))}
          style={{ width: 84, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        >
          {levels.map((l) => (
            <option key={l} value={l}>{l}%</option>
          ))}
        </select>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <label style={{ fontSize: 11, color: 'var(--muted)' }}>Swing bars</label>
        <input
          type="number"
          min={5}
          value={data.swing_lookback ?? 100}
          onChange={(e) => onChange('swing_lookback', Math.max(5, parseInt(e.target.value, 10) || 100))}
          style={{ width: 74, padding: 3, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#d97706' }} />
    </div>
  );
}
